module.exports = __webpack_public_path__ + "static/media/6820.85c1dbdc.jpg";